const openUtilitySwitchingHelp = () =>
  window.open("https://utility-switching-help.scrollhelp.site/home/");

export { openUtilitySwitchingHelp };
